export const getPlayUrl = (id,rss=false) => {
    if (id?.toString()=="0") return ``
    if (!rss) return `/api/public/v0/post/play.mp4?id=${id}&x=0&f=0&r=`
    if (rss) return `/api/public/v0/post/play.mp4?id=${id}&amp;x=0&amp;f=0&amp;r=podcast`
    //if (rss) return `/api/public/v0/post/play.mp4${encodeURIComponent(`?id=${id}&x=0&f=0&r=`)}`
    //id = post_id
    //x = index in case of multiple post attachments
    //f = follower or not
    //r = referral
}